import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabservice() {



  const cardData = {
"keyword": "Pune to Goa Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Goa Cab Service for travelers seeking safe, affordable, and enjoyable long-distance travel. Whether you are planning a beach vacation, family trip, honeymoon, corporate outing, or weekend getaway, our taxi service ensures a smooth and stress-free journey from Pune to Goa. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience for every customer. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable road trip experience between Pune and Goa.",

"topPlaces": [
  {
    "title": "Baga Beach",
    "description":
      "Baga Beach is one of Goa’s most popular tourist destinations known for nightlife, water sports, and beach shacks. Travelers using Pune to Goa cab service often visit this lively beach for entertainment and relaxation."
  },
  {
    "title": "Calangute Beach",
    "description":
      "Calangute Beach is famous for its vibrant atmosphere, shopping stalls, and seaside activities. Cab travelers from Pune enjoy spending time at this iconic Goa beach destination."
  },
  {
    "title": "Fort Aguada",
    "description":
      "Fort Aguada is a historic Portuguese fort in Goa offering panoramic sea views and heritage architecture. Pune to Goa taxi service provides convenient access for sightseeing enthusiasts."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description":
      "Dudhsagar Waterfalls is a breathtaking natural attraction known for cascading white waters and forest surroundings. Travelers often book Pune to Goa cabs to explore this scenic destination."
  },
  {
    "title": "Anjuna Beach",
    "description":
      "Anjuna Beach is known for its nightlife, flea markets, and relaxed coastal vibe. Taxi from Pune to Goa offers a comfortable journey to this popular beach area."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description":
      "Basilica of Bom Jesus is a UNESCO World Heritage Site famous for its historic church architecture and religious importance. Pune to Goa cab booking is ideal for cultural and spiritual tourism."
  },
  {
    "title": "Candolim Beach",
    "description":
      "Candolim Beach is a peaceful beach destination in Goa known for resorts, water sports, and relaxing surroundings. Travelers from Pune often choose this location for family vacations."
  },
  {
    "title": "Chapora Fort",
    "description":
      "Chapora Fort is a famous hilltop fort offering stunning views of the Arabian Sea and nearby beaches. Pune to Goa cab service makes it easy to visit this scenic landmark."
  },
  {
    "title": "Palolem Beach",
    "description":
      "Palolem Beach is a serene and picturesque beach in South Goa ideal for relaxation and peaceful stays. Cab travelers from Pune enjoy visiting this beautiful coastal destination."
  },
  {
    "title": "Panaji",
    "description":
      "Panaji is the capital city of Goa known for colorful streets, casinos, churches, and riverside views. Pune to Goa taxi service offers smooth travel for tourists exploring the city."
  }
],



services: [
  {
    name: "Pune to Goa Cab",
    description: "Pune to Goa cab service provides reliable long-distance transportation between Pune and Goa with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, tourists, and holiday travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Goa. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Goa Taxi",
    description: "Pune to Goa taxi service offers dependable transportation for passengers traveling between Pune and Goa with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for vacations, beach tours, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Goa. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Goa",
    description: "Cab from Pune to Goa service provides comfortable intercity transportation for passengers traveling for tourism, beach holidays, and family vacations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Goa. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Goa",
    description: "Taxi from Pune to Goa service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Goa. Vehicles provide smooth highway travel suitable for tourism, holiday tours, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Goa. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Goa Cab Service",
    description: "Pune to Goa cab service provides dependable transportation solutions for passengers traveling between Pune and Goa with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Goa. Ideal for beach holidays, tourism, and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Goa Taxi Fare",
    description: "Pune to Goa taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Goa. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Goa. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Goa One Way Cab",
    description: "Pune to Goa one way cab service provides economical transportation for passengers traveling from Pune to Goa without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for vacations, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Goa including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Goa Round Trip Taxi",
    description: "Pune to Goa round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Goa. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Goa. Ideal for holiday travel, tourism, and family vacations. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Goa Cab Booking",
    description: "Pune to Goa cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Goa. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Goa. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Goa Cab",
    description: "Cheap Pune to Goa cab service provides affordable transportation between Pune and Goa with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for holiday trips, tourism, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Goa. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Goa Taxi",
    description: "Best Pune to Goa taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for holiday travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Goa. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Goa Cab",
    description: "Sedan Pune to Goa cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Goa. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Goa. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Goa Taxi",
    description: "SUV Pune to Goa taxi service provides spacious transportation for families and groups traveling between Pune and Goa. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Goa. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Goa Cab",
    description: "Innova Pune to Goa cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for beach holidays, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Goa. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Family Trip Cab Pune Goa",
    description: "Family trip cab Pune Goa service provides comfortable transportation for families traveling from Pune to Goa for vacations and holiday tours. Spacious vehicles ensure smooth highway journeys with comfortable seating and luggage capacity suitable for long-distance travel. Professional drivers ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Goa. Flexible booking options allow convenient family tour cab reservations."
  },
  {
    name: "Pune to Goa Holiday Cab Package",
    description: "Pune to Goa holiday cab package service provides complete travel solutions for passengers planning Goa vacations from Pune. Comfortable vehicles ensure reliable highway travel suitable for beach holidays, sightseeing tours, and family trips. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Goa. Flexible booking options allow convenient Goa holiday package cab reservations."
  }
],

tableData: [
  ["Pune to Goa Cab", "Pune to Goa Taxi"],
  ["Cab from Pune to Goa", "Taxi from Pune to Goa"],
  ["Pune to Goa Cab Service", "Pune to Goa Taxi Fare"],
  ["Pune to Goa One Way Cab", "Pune to Goa Round Trip Taxi"],
  ["Pune to Goa Cab Booking", "Cheap Pune to Goa Cab"],
  ["Best Pune to Goa Taxi", "Sedan Pune to Goa Cab"],
  ["SUV Pune to Goa Taxi", "Innova Pune to Goa Cab"],
  ["Family Trip Cab Pune Goa", "Pune to Goa Holiday Cab Package"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Goa Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Goa cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe long-distance travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Goa Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Goa cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Goa Cab Service Availability",
        WhyChoosedescription: "Our Pune to Goa cab service operates 24 hours a day for family vacations, beach tours, business travel, group trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Goa Taxi Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Goa taxi service, round-trip bookings, Goa sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Goa Highway Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Goa highway routes and ghat sections, ensuring safe driving, smooth travel, and timely arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Goa cab service?", answer: "Pune to Goa cab service provides comfortable taxi transportation between Pune and Goa for family vacations, beach tours, and long-distance travel." },
    { question: "Is Pune to Goa cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Goa cab service." },
    { question: "Which vehicles are available for Pune to Goa travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Goa?", answer: "Yes, customers can book one-way as well as round-trip Pune to Goa taxi services." },
    { question: "Do you provide Goa sightseeing cab packages?", answer: "Yes, Shivai Travels provides Goa sightseeing and customized tour packages." },
    { question: "Are all Pune to Goa taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Goa cab service online?", answer: "Yes, customers can easily book Pune to Goa cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family vacations and group tours." },
    { question: "Are Pune to Goa cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Goa cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Deshpande",
      feedback:
        "Booked Pune to Goa cab service with Shivai Travels. Comfortable vehicle, experienced driver, and amazing travel experience.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Pooja Shah",
      feedback:
        "Excellent Pune to Goa taxi service. Affordable pricing, smooth highway journey, and very professional support.",
      rating: 5
    }
  ];


































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-goa-cab.jpg",
  "description": "Book Pune to Goa cab service for safe and comfortable family and group travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for long-distance coastal journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹13/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-goa-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Goa Cab Service | Affordable Family Trip Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Goa cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for safe family and group trips."
  />

  <meta
    name="keywords"
    content="pune to goa cab, pune to goa taxi, cab from pune to goa, taxi from pune to goa, pune to goa cab service, pune to goa taxi fare, pune to goa one way cab, pune to goa round trip taxi, pune to goa cab booking, cheap pune to goa cab, best pune to goa taxi, sedan pune to goa cab, suv pune to goa taxi, innova pune to goa cab, family trip cab pune goa, Pune to Goa Cab, Pune to Goa Cab Service, Pune to Goa Taxi Service, Pune to Goa Cab Booking, Best Pune to Goa Cab, One Way Pune to Goa Cab, Round Trip Pune to Goa Taxi, Cheap Pune to Goa Cab, 24x7 Pune to Goa Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabservice;